import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../../config/firebase';
import { authService } from '../../utils/api/auth.service';
import { useAuth } from '../../context/AuthContext';
import { SEO } from '../../components/SEO/SEO';
import './SignUp.css';

export const SignUp = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    password: '',
    age: '0',
    gender: 'Other',
    address: 'Not provided'
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await authService.signup(formData);
      console.log('Sign Up Success:', data);
      login(data.user || data); // Automatically log in after signup
      alert('Account created successfully!');
      navigate('/');
    } catch (error) {
      console.error('Sign Up Error:', error.message);
      alert(error.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      console.log('Google Sign Up Success:', user);
      
      const signupData = {
        full_name: user.displayName || '',
        email: user.email || '',
        password: user.email, // Using email as password for Google users per user request
        age: '0',
        gender: 'Other',
        address: 'Not provided'
      };

      // Call signup API directly with the data from Google
      const data = await authService.signup(signupData);
      
      // Merge backend data with Google photoURL
      const sessionUser = {
        ...(data.user || data),
        photoURL: user.photoURL
      };
      
      login(sessionUser);
      navigate('/');

    } catch (error) {
      console.error('Google Sign Up Error:', error.message);
      alert('Google Sign Up failed. Please try again.');
    }
  };

  return (
    <>
      <SEO 
        title="Create Account | Join Hobi Hub - Start Your Experience Journey"
        description="Sign up for Hobi Hub and start discovering amazing events and experiences. Create your free account to book workshops, activities, and adventures in your city."
        keywords="Hobi Hub signup, create account, register, join Hobi, new account, event booking"
        canonicalUrl="https://hobi.co.in/signup"
      />
      <div className="signup-page-container">
        {/* Left Side - Auth Form */}
        <div className="signup-left">
          <div className="signup-auth-content">
            <h1>Create Account</h1>
            <p className="subtitle">Enter your details to get started with Hobi</p>

          <form onSubmit={handleSubmit} className="signup-form-new">
            <div className="signup-input-container full-width">
              <label>Full Name</label>
              <input 
                type="text" 
                name="full_name"
                placeholder="Enter your full name"
                value={formData.full_name}
                onChange={handleChange}
                required
              />
            </div>

            

            <div className="signup-input-container full-width">
              <label>Email Address</label>
              <input 
                type="email" 
                name="email"
                placeholder="email@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

          

            <div className="signup-input-container full-width">
              <label>Password</label>
              <div className="password-input-wrapper">
                <input 
                  type={showPassword ? "text" : "password"} 
                  name="password"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  )}
                </button>
              </div>
            </div>

            <button type="submit" className="signup-button" disabled={loading}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>

            <div className="signup-divider-new">or sign up with</div>

            <button type="button" onClick={handleGoogleSignUp} className="signup-google-btn-new">
              <img src="/images/Google__G__logo.svg.png" alt="Google" className="login-google-icon-new" />
              Sign up with Google
            </button>

          
          </form>

          <p className="signup-login-text">
            Already have an account? <Link to="/login">Sign In</Link>
          </p>
        </div>
      </div>

      {/* Right Side - Branding/Image */}
      <div className="signup-right">
        <div className="signup-right-pattern" style={{ backgroundImage: "url('/images/homebg.svg')" }}></div>
        <Link to="/" className="signup-logo-top">
          <img src="/images/hobi-white.svg" alt="Hobi Logo" />
        </Link>
        <div className="signup-feature-image-wrapper">
          <img 
            src="/images/bg-edited.svg" 
            alt="Hobi Background" 
            className="feature-image-signup"
          />
        </div>
      </div>
      </div>
    </>
  );
};
